var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('NavbarWorld'),_c('ConocenosWorld'),_c('PromoRepair'),_c('ServiceCarousel'),_c('EmpresasAsociadas'),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }